import * as React from 'react'
import injectSheet from 'react-jss'
import {TableCellProps} from 'material-ui-next/Table'
import TableCell from 'material-ui-next/Table/TableCell'

const styles = {
    root: {
        position: 'relative',
    }
}

export const CisTableCell =
    injectSheet<TableCellProps>(styles)(
        ({classes, className, ...props}) => (
            <TableCell className={`${classes.root} ${className}`} {...props}/>
        )
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/CisTableCell.tsx